export enum InstrumentType {
  stand = 'standard',
  asicPro = 'standard',
  secstand = 'standard',
  secstandPro = 'standard',
  demoStand = 'standard',
  demoStandPro = 'standard',
  cent = 'cent',
  seccent = 'cent',
  seccentPro = 'cent',
  demoCentPro = 'cent',
  demoSecCent = 'cent',
  asicCentPro = 'cent',
  ecn = 'ecn',
  asicEcnPro = 'ecn',
  micro = 'micro',
  unlim = 'unlimited',
  zero = 'zerospread',
  crypto = 'crypto',
  demoCrypto = 'demoCrypto',
  tp = 'tp',
  demoTp = 'tp',
  tpCrypto = 'tpcrypto',
  demoTpCrypto = 'tpcrypto',
  professional = 'pro',
}

export interface InstrumentGroup {
  id: number;
  title: string;
}

export interface Instrument {
  groupId: number;
  id: number;
  lotSize: number;
  minSpread: number;
  spread: number;
  stopLevel: number;
  swapBuy: number;
  swapSell: number;
  symbol: string;
  title: string;
  baseCurrency: string;
}
